module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing_m_en.425a0dc724fa2641a0bbacbb10ba84b6.png";